import * as actionTypes from './actionTypes'

import { getListingIndex } from '../../helpers/utils'
import { enqueueSnackbar } from './alert'
import positionAxios from '../../axios/position'
import { saveFileFromResponse } from '../../helpers/utils'

export const fetchPosition = filterOptions => {
  return dispatch => {
    const params = {
      ...filterOptions,
      page: filterOptions ? filterOptions.page : 1,
      perPage: filterOptions ? filterOptions.perPage : 10
    }

    dispatch(fetchPositionStart())

    positionAxios
      .get('', { params })
      .then(response => {
        if (response.status === 200 && response.data.success) {
          const { current_page, from, last_page, per_page, to, total, data } = response.data.data

          const pagination = {
            currentPage: current_page,
            lastPage: last_page,
            perPage: per_page,
            from,
            to,
            total
          }

          const dataWithOption = data.map((item, index) => {
            return { ...item, index: getListingIndex(index, per_page, current_page) }
          })

          dispatch(fetchPositionSuccess(pagination, dataWithOption))
        }
      })
      .catch(error => {
        dispatch(fetchPositionFailed(error))
      })
  }
}

export const fetchPositionStart = () => {
  return {
    type: actionTypes.FETCH_POSITION_START
  }
}

export const fetchPositionSuccess = (pagination, records) => {
  return {
    type: actionTypes.FETCH_POSITION_SUCCESS,
    pagination,
    records
  }
}

export const fetchPositionFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_POSITION_FAILED,
    errorMessage
  }
}

export const fetchPositionById = recordId => {
  return dispatch => {
    dispatch(fetchPositionStart())
    positionAxios
      .get(`/${recordId}`)
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchPositionByIdSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchPositionFailed(error))
      })
  }
}

export const fetchPositionByIdSuccess = recordData => {
  return {
    type: actionTypes.FETCH_POSITION_BY_ID_SUCCESS,
    recordData
  }
}

export const clearSelectedPositionRecord = () => {
  return {
    type: actionTypes.CLEAR_SELECTED_POSITION_RECORD
  }
}

export const createPosition = (recordData, page) => {
  return dispatch => {
    dispatch(createPositionStart())

    positionAxios
      .post('', recordData)
      .then(response => {
        if (response.status === 201) {
          dispatch(
            enqueueSnackbar({
              message: 'Position Created',
              options: {
                variant: 'success'
              }
            })
          )
          dispatch(createPositionSuccess())
          dispatch(fetchPosition(page))
        }
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Position field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(createPositionFailed())
      })
  }
}

export const createPositionStart = () => {
  return {
    type: actionTypes.CREATE_POSITION_START
  }
}

export const createPositionSuccess = () => {
  return {
    type: actionTypes.CREATE_POSITION_SUCCESS
  }
}

export const createPositionFailed = () => {
  return {
    type: actionTypes.CREATE_POSITION_FAILED
  }
}

export const updatePosition = (recordId, recordData, page) => {
  return dispatch => {
    dispatch(updatePositionStart())

    positionAxios
      .patch(`/${recordId}`, recordData)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'Position Updated',
            options: {
              variant: 'success'
            }
          })
        )
        dispatch(updatePositionSuccess())
        dispatch(fetchPosition(page))
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Position field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(updatePositionFailed())
      })
  }
}

export const updatePositionStart = () => {
  return {
    type: actionTypes.UPDATE_POSITION_START
  }
}

export const updatePositionSuccess = () => {
  return {
    type: actionTypes.UPDATE_POSITION_SUCCESS
  }
}

export const updatePositionFailed = () => {
  return {
    type: actionTypes.UPDATE_POSITION_FAILED
  }
}

export const deletePosition = (recordId, page) => {
  return dispatch => {
    dispatch(deletePositionStart())
    positionAxios
      .delete(`/${recordId}`)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'Position Deleted',
            options: {
              key: recordId,
              variant: 'success'
            }
          })
        )
        dispatch(deletePositionSuccess())
        dispatch(fetchPosition(page))
      })
      .catch(error => {
        dispatch(
          enqueueSnackbar({
            message: error.response.data.message,
            options: {
              variant: 'error'
            }
          })
        )
        dispatch(deletePositionFailed())
      })
  }
}

export const deletePositionStart = () => {
  return {
    type: actionTypes.DELETE_POSITION_START
  }
}

export const deletePositionSuccess = () => {
  return {
    type: actionTypes.DELETE_POSITION_SUCCESS
  }
}

export const deletePositionFailed = () => {
  return {
    type: actionTypes.DELETE_POSITION_FAILED
  }
}

export const importPosition = importFile => {
  return dispatch => {
    dispatch(importPositionStart())
    let formData = new FormData()
    formData.append('file', importFile)

    positionAxios
      .post('/import', formData)
      .then(response => {
        if (response.status === 200) {
          dispatch(importPositionSuccess(response.data))
          dispatch(
            enqueueSnackbar({
              message: 'Position Imported',
              options: {
                variant: 'success'
              }
            })
          )
          dispatch(fetchPosition())
        }
      })
      .catch(error => {
        dispatch(
          enqueueSnackbar({
            message: 'Position Imported Error',
            options: {
              variant: 'error',
              data: error.response.data.data
            }
          })
        )
        dispatch(importPositionFailed(error))
      })
  }
}

export const importPositionStart = () => {
  return {
    type: actionTypes.IMPORT_LEVEL_START
  }
}

export const importPositionSuccess = () => {
  return {
    type: actionTypes.IMPORT_LEVEL_SUCCESS
  }
}

export const importPositionFailed = errorMessage => {
  return {
    type: actionTypes.IMPORT_LEVEL_FAILED,
    errorMessage
  }
}

export const exportPosition = filterOptions => {
  return dispatch => {
    dispatch(exportPositionsStart())
    let params = null
    if (filterOptions) {
      params = {
        ...filterOptions
      }
    }
    positionAxios
      .get('/export', {
        params,
        responseType: 'blob'
      })
      .then(response => {
        if (response.status === 200) {
          saveFileFromResponse(response)
          dispatch(
            enqueueSnackbar({
              message: 'Position Exported',
              options: {
                variant: 'success'
              }
            })
          )
          dispatch(exportPositionSuccess())
        }
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Position field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.data,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(exportPositionFailed(error))
      })
  }
}

export const exportPositionsStart = () => {
  return {
    type: actionTypes.EXPORT_LEVEL_START
  }
}

export const exportPositionSuccess = () => {
  return {
    type: actionTypes.EXPORT_LEVEL_SUCCESS
  }
}

export const exportPositionFailed = errorMessage => {
  return {
    type: actionTypes.EXPORT_LEVEL_FAILED,
    errorMessage
  }
}

export const downloadPositionTemplate = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(downloadPositionTemplateStart())
    positionAxios
      .get('/download', {
        responseType: 'blob',
        params
      })
      .then(response => {
        if (response.status === 200) {
          saveFileFromResponse(response)
          dispatch(
            enqueueSnackbar({
              message: 'Position Template Downloaded',
              options: {
                variant: 'success'
              }
            })
          )
          dispatch(downloadPositionTemplateSuccess())
        }
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Position field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.data,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(downloadPositionTemplateFailed(error))
      })
  }
}

export const downloadPositionTemplateStart = () => {
  return {
    type: actionTypes.DOWNLOAD_LEVEL_TEMPLATE_START
  }
}

export const downloadPositionTemplateSuccess = () => {
  return {
    type: actionTypes.DOWNLOAD_LEVEL_TEMPLATE_SUCCESS
  }
}

export const downloadPositionTemplateFailed = errorMessage => {
  return {
    type: actionTypes.DOWNLOAD_LEVEL_TEMPLATE_FAILED,
    errorMessage
  }
}

export const fetchPositionFilterCompany = filter => {
  return dispatch => {
    dispatch(fetchPositionFilterCompanyStart())
    positionAxios
      .get('/company/dropdown', { params: filter })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchPositionFilterCompanySuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchPositionFilterCompanyFailed(error))
      })
  }
}

export const fetchPositionFilterCompanyStart = () => {
  return {
    type: actionTypes.FETCH_POSITION_FILTER_COMPANY_START
  }
}

export const fetchPositionFilterCompanySuccess = data => {
  return {
    type: actionTypes.FETCH_POSITION_FILTER_COMPANY_SUCCESS,
    data
  }
}

export const fetchPositionFilterCompanyFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_POSITION_FILTER_COMPANY_FAILED,
    errorMessage
  }
}

export const fetchPositionFilterPosition = filter => {
  return dispatch => {
    dispatch(fetchPositionFilterPositionStart())
    positionAxios
      .get('/dropdown', { params: filter })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchPositionFilterPositionSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchPositionFilterPositionFailed(error))
      })
  }
}

export const fetchPositionFilterPositionStart = () => {
  return {
    type: actionTypes.FETCH_POSITION_FILTER_POSITION_START
  }
}

export const fetchPositionFilterPositionSuccess = data => {
  return {
    type: actionTypes.FETCH_POSITION_FILTER_POSITION_SUCCESS,
    data
  }
}

export const fetchPositionFilterPositionFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_POSITION_FILTER_POSITION_FAILED,
    errorMessage
  }
}
